/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

import Plot from "react-plotly.js";

const SIGNAL_COLORS = {
    "Long Build-up": "#22c55e",
    "Short Build-up": "#ef4444",
    "Short Covering": "#3b82f6",
    "Long Unwinding": "#f59e0b",
    "Put Writing": "#10b981",
    "Call Writing": "#dc2626",
    "Put Unwinding": "#facc15",
    "Call Unwinding": "#60a5fa"
};

function filterByOI(optionData) {

    const grouped = {};

    optionData.forEach(item => {

        const key =
            `${item.expiry}_${item.option_type}`;

        if (!grouped[key]) {
            grouped[key] = [];
        }

        grouped[key].push(item);

    });

    const filtered = [];

    Object.keys(grouped).forEach(key => {

        const rows = grouped[key];

        const totalOI =
            rows.reduce(
                (acc, row) =>
                    acc + (row.oi || 0),
                0
            );

        const threshold =
            totalOI * 0.05;

        rows.forEach(row => {

            if (
                (row.oi || 0) >= threshold
            ) {

                filtered.push(row);

            }

        });

    });

    return filtered;

}

export default function OptionsSignalBubbleChart({

    signalData = []

}) {

    const topExpiries =
        [...new Set(
            signalData.map(
                d => d.expiry
            )
        )]
            .sort(
                (a, b) =>
                    new Date(a) -
                    new Date(b)
            )
            .slice(0, 3);

    const filteredData =
        filterByOI(

            signalData.filter(
                row =>
                    topExpiries.includes(
                        row.expiry
                    )
            )

        );

    const signals =
        [...new Set(
            filteredData.map(
                d => d.signal
            )
        )];

    const traces = signals.map(signal => {

        const rows =
            filteredData.filter(
                d => d.signal === signal
            );

        return {

            x: rows.map(
                r => r.strike
            ),

            y: rows.map(
                r => r.expiry
            ),

            text: rows.map(
                r =>
                    `
${r.symbol || ""}
${r.option_type}
Strike: ${r.strike}
OI: ${(r.oi || 0).toLocaleString()}
Signal: ${r.signal}
                    `
            ),

            mode: "markers",

            type: "scatter",

            name: signal,

            hovertemplate:
                "%{text}<extra></extra>",

            marker: {

                color:
                    SIGNAL_COLORS[
                        signal
                    ] ||
                    "#94a3b8",

                size: rows.map(
                    r =>
                        Math.max(
                            12,
                            Math.sqrt(
                                r.oi || 1
                            ) / 15
                        )
                ),

                sizemode: "area",

                opacity: 0.75,

                line: {
                    width: 1,
                    color: "#0f172a"
                }

            }

        };

    });

    return (

        <div
            className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-4
            "
        >

            <div
                className="
                    flex
                    justify-between
                    items-center
                    mb-4
                "
            >

                <div>

                    <h2
                        className="
                            text-xl
                            font-bold
                            text-white
                        "
                    >
                        Options Activity Heatmap
                    </h2>

                    <p
                        className="
                            text-sm
                            text-slate-400
                        "
                    >
                        Top 3 expiries · OI weighted
                        signal bubbles
                    </p>

                </div>

            </div>

            <Plot
                data={traces}
                layout={{

                    height: 650,

                    paper_bgcolor:
                        "#020617",

                    plot_bgcolor:
                        "#020617",

                    font: {
                        color: "#cbd5e1"
                    },

                    margin: {
                        l: 60,
                        r: 20,
                        t: 40,
                        b: 80
                    },

                    xaxis: {

                        title:
                            "Strike Price",

                        gridcolor:
                            "#1e293b",

                        zeroline: false

                    },

                    yaxis: {

                        title:
                            "Expiry",

                        type: "category",

                        gridcolor:
                            "#1e293b"

                    },

                    hovermode:
                        "closest",

                    legend: {

                        orientation: "h",

                        y: -0.18

                    }

                }}
                config={{
                    responsive: true,
                    displayModeBar: false
                }}
                style={{
                    width: "100%"
                }}
            />

        </div>

    );

}